/* eslint-disable import/no-extraneous-dependencies */
import React, { useState } from 'react';
import TkbFilterBar from './TkbFilterBar';
const sampleChips = [
    { key: 'upload_date', label: 'Upload Date' },
    { key: 'uploaded_by', label: 'Uploaded By' },
    { key: 'audience', label: 'Audience' }
];
const meta = {
    title: 'Features/Settings/TenantKnowledgeBase/TkbFilterBar',
    component: TkbFilterBar,
    parameters: {
        layout: 'padded'
    },
    args: {
        addLabel: 'Add Document',
        // eslint-disable-next-line no-alert
        onAdd: () => alert('Add clicked'),
        searchId: 'tkb-search',
        searchPlaceholder: 'Search documents…',
        filterChips: sampleChips,
        filterLabel: 'Filter by:',
        showInactiveId: 'tkb-show-inactive',
        showInactiveLabel: 'Show inactive'
    }
};
export default meta;
/**
 * Default toolbar — Add action, filter chips, Show-Inactive checkbox, and search.
 * Stateful render so the controls are interactive in the Storybook canvas.
 */
export const Default = {
    render: (args) => {
        const [searchValue, setSearchValue] = useState('');
        const [showInactive, setShowInactive] = useState(false);
        return (React.createElement(TkbFilterBar
        // eslint-disable-next-line react/jsx-props-no-spreading
        , Object.assign({}, args, { searchValue: searchValue, onSearchChange: setSearchValue, showInactive: showInactive, onShowInactiveChange: setShowInactive })));
    }
};
/**
 * No filter chips and no extra children — just Add + Show Inactive + Search.
 */
export const Minimal = {
    render: (args) => {
        const [searchValue, setSearchValue] = useState('');
        const [showInactive, setShowInactive] = useState(false);
        return (React.createElement(TkbFilterBar
        // eslint-disable-next-line react/jsx-props-no-spreading
        , Object.assign({}, args, { filterChips: [], searchValue: searchValue, onSearchChange: setSearchValue, showInactive: showInactive, onShowInactiveChange: setShowInactive })));
    }
};
